import { getCurrentCulture, getCurrentLanguage, isCurrentCultureRightToLeft } from 'owa-localize';

export default function useSuiteHeaderLanguageProps() {
    return {
        culture: getCurrentCulture(),
        language: getCurrentLanguage(),
        isRTL: isCurrentCultureRightToLeft(),
    };
}
